import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllSmsAction } from '../../../redux/actions/communicationAction';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  FormControl,
  Select,
  Pagination,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Sms = ({ data, policyNumber, pagination, customerId, poppinsFont }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (customerId) {
  //     dispatch(getAllSmsAction(customerId, page, rowsPerPage));
  //   }
  // }, [dispatch, customerId]);

  const handleChangePageSms = (event, newPage) => {
    setPage(newPage - 1);
    if (customerId) {
      dispatch(getAllSmsAction(customerId, newPage - 1, rowsPerPage));
    }
  };

  const handleChangeRowsPerPageSms = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page
    if (customerId) {
      dispatch(getAllSmsAction(customerId, 0, newRowsPerPage));
    }
  };

  return (
    <Box sx={{ ml: 2, mr: 2, mb: 2, mt: 2 }}>
      <Accordion defaultExpanded sx={{ mt: 2, backgroundColor: '#f5f5f5' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={poppinsFont}>SMS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {data && data.length > 0 ? (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Policy Number
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Phone Number
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Date
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Message
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Status
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Direction
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow className="styled-table-row" key={row.id || index}>
                        <TableCell>{row.policyNumber || policyNumber || '-'}</TableCell>
                        <TableCell>{row.phoneNumber || row.phone || '-'}</TableCell>
                        <TableCell>{row.date || row.createdAt || '-'}</TableCell>
                        <TableCell sx={{ maxWidth: 300, wordWrap: 'break-word' }}>
                          {row.message || row.content || '-'}
                        </TableCell>
                        <TableCell>{row.status || '-'}</TableCell>
                        <TableCell>{row.direction || row.type || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {pagination && pagination.totalElements > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  mt={2}
                  px={2}
                >
                  <span style={{ marginRight: 8, fontSize: '14px' }}>
                    Rows per page:
                  </span>
                  <FormControl size="small">
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPageSms}
                      displayEmpty
                    >
                      {[5, 10, 25].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Pagination
                    count={Math.ceil(pagination.totalElements / rowsPerPage)}
                    page={page + 1} // Convert 0-based to 1-based for display
                    onChange={handleChangePageSms}
                  />
                </Box>
              )}
            </>
          ) : (
            <Typography align="center" sx={{ mt: 2 }}>
              No SMS Records Found
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Sms;